import * as angular from 'angular';
import nvSupportsModule from '../../../_module';

export class SupportStepDescriptionCtrl {
  static $inject = ['$scope'];

  public currentSupport;

  constructor(private $scope) {}

  $onInit(): void {
    // empty block
  }
}

angular.module(nvSupportsModule).controller('supportStepDescriptionCtrl', SupportStepDescriptionCtrl);
